import React from 'react'
import Card from './Card'

function Catalog() {

  return (
    <div className=' container '>
      <div className=' w-full bg-[#03236F]'>
        <p className='text-center text-white font-sans text-5xl font-normal py-16'>
        Top Categories
        </p>
      </div>
      <div className='w-[50%] flex my-10 border border-gray-300 py-3 rounded-md mx-auto hover:cursor-text'>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-7 opacity-50 mx-[4%]">
          <path strokeLinecap="round" strokeLinejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
        </svg>
        <input className='text-base focus:outline-none w-[100%]' type="text" placeholder='Search for Industries'/>
      </div>
      <div className='grid grid-cols-3 mx-[10%]'>
        <Card 
          image="/findProjectImages/image 161 (1).png"
          title="Metallurgical"
        />
        <Card 
          image="/findProjectImages/image 161.png"
          title="Chemicals"
        />
        <Card 
          image="/findProjectImages/image 162 (1).png"
          title="Services To Industries"
        />
        <Card 
          image="/findProjectImages/image 162.png"
          title="Electrical & Electronics"
        />
        <Card 
          image="/findProjectImages/image 163 (1).png"
          title="Automobile"
        />
        <Card 
          image="/findProjectImages/image 163.png"
          title="Machinery"
        />
        <Card 
          image="/findProjectImages/istockphoto-1057719100-612x612 2.png"
          title="Manufacturing"
        />
        <Card 
          image="/findProjectImages/istockphoto-1798490096-612x612 3.png"
          title="Mechanical"
        />
        <Card 
          image="/findProjectImages/istockphoto-517743436-612x612 4.png"
          title="Biomedical"
        />
      </div>
        
    </div>
  )
}

export default Catalog;
